import CallOutcomeComponent from './CallOutcome.component';

export * from "./CallOutcome.component";
export default CallOutcomeComponent;
